import { ROUTES } from "../config/site";

/**
 * One entry per indexable URL.
 *
 * Each route has its own dedicated page component, metadata, and structured
 * schema, maximizing SEO, GEO, and AEO authority across all 7 UAE emirates.
 */
const routes = [
  {
    path: [ROUTES.home.path],
    exact: true,
    component: "Home",
  },
  {
    path: [ROUTES.uaeEmirates.path],
    exact: true,
    component: "UAEEmirates",
  },
  {
    path: [ROUTES.sellDubai.path],
    exact: true,
    component: "SellDubai",
  },
  {
    path: [ROUTES.sellAbuDhabi.path],
    exact: true,
    component: "SellAbuDhabi",
  },
  {
    path: [ROUTES.sellSharjah.path],
    exact: true,
    component: "SellSharjah",
  },
  {
    path: [ROUTES.sellAjman.path],
    exact: true,
    component: "SellAjman",
  },
  {
    path: [ROUTES.sellRasAlKhaimah.path],
    exact: true,
    component: "SellRasAlKhaimah",
  },
  {
    path: [ROUTES.sellFujairah.path],
    exact: true,
    component: "SellFujairah",
  },
  {
    path: [ROUTES.sellUmmAlQuwain.path],
    exact: true,
    component: "SellUmmAlQuwain",
  },
  {
    path: [ROUTES.materials.path],
    exact: true,
    component: "Materials",
  },
  {
    path: [ROUTES.recycling.path],
    exact: true,
    component: "Recycling",
  },
  {
    path: [ROUTES.resources.path],
    exact: true,
    component: "Resources",
  },
  {
    path: [ROUTES.about.path],
    exact: true,
    component: "About",
  },
  {
    path: [ROUTES.contact.path],
    exact: true,
    component: "Contact",
  },
];

export default routes;
